import { Storage } from "@ionic/storage-angular";

export abstract class BaseStorageRepository<T> {
  constructor(
    protected storage: Storage,
    protected key: string,
  ) {}

  public set(value: T): Promise<T> {
    return this.storage.set(this.key, value);
  }

  public get(): Promise<T> {
    return this.storage.get(this.key);
  }

  public clear(): Promise<void> {
    return this.storage.remove(this.key);
  }
}
